import { GamingHistoryStore } from "@state/stores/games/history";
import { createContext } from "react";

// @ts-expect-error
export default createContext<GamingHistoryStore>(new GamingHistoryStore(null));
